<template>
    <rkm-layout-body title="Aprovação de entrada">
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/almoxarifado/cliente/aprovacao-entrada/List'

export default {
    components: {List},
}
</script>